var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMapMarker1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_map-marker",
    "data-name": "Icon - map-marker",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15.84,
    viewBox: "0 0 12 15.84",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location-dot-light",
    d: "M8.3,5.818A2.442,2.442,0,1,1,5.861,3.394,2.433,2.433,0,0,1,8.3,5.818ZM5.861,7.272A1.454,1.454,0,1,0,4.4,5.818,1.46,1.46,0,0,0,5.861,7.272Zm5.861-1.454c0,2.648-3.572,7.363-5.138,9.308a.927.927,0,0,1-1.447,0C3.544,13.181,0,8.466,0,5.818a5.861,5.861,0,0,1,11.723,0ZM5.861.97A4.865,4.865,0,0,0,.977,5.818a5.286,5.286,0,0,0,.506,1.921,18.724,18.724,0,0,0,1.33,2.488,45.325,45.325,0,0,0,3.049,4.245,45.531,45.531,0,0,0,3.05-4.245,18.8,18.8,0,0,0,1.328-2.488,5.249,5.249,0,0,0,.507-1.921A4.865,4.865,0,0,0,5.861.97Z",
    transform: "translate(0.277 0.366)",
    fill: "#047BC1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMapMarker1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - map-marker-1.626086a28d147f2d73e7eddd6f2c5db1.svg";